import React from "react";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { Switch } from "@/components/ui/switch";

export function PartnersIntegrationEnabledRow({
  checked,
  disabled,
  onChange,
}: {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();

  const id = "partners-integration-enabled";
  const readOnly = !onChange;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <Switch
          id={id}
          checked={checked}
          disabled={readOnly || disabled}
          onCheckedChange={onChange}
        />
        <Label htmlFor={id} className="text-md">
          {t("billing.partnersIntegrationEnabled")}
        </Label>
      </div>
      {readOnly ? (
        <p className="text-xs leading-5 text-black/55">
          {t("billing.partnersIntegrationEnabledHint")}
        </p>
      ) : null}
    </div>
  );
}
